import { useEffect } from 'react';

import { MESSAGE_STATE_SUCCESS } from 'constants/message-app-state-contants';
import { useDocumentTitle } from 'hooks/document-title';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { Loading } from 'components/Loading/Loading';

import { messagePopUp } from 'api/app-slice';
import { validateUser } from 'api/user-slice';

const ValidateUser = () => {
  useDocumentTitle('Validate User | Checkmate');

  const { t } = useTranslation();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { token } = useParams();

  useEffect(() => {
    dispatch(validateUser(token))
      .unwrap()
      .then(() => {
        dispatch(
          messagePopUp({
            text: t('signIn.emailVerified'),
            state: MESSAGE_STATE_SUCCESS,
            hide: true,
          }),
        );
        navigate('/sign_in?reason=email_verified');
      })
      .catch(() => navigate('/sign_in?reason=verification_link_invalid'));
  }, []);

  return <Loading active={true} />;
};

export default ValidateUser;
